import { render, staticRenderFns } from "./mobile-nav-main.vue?vue&type=template&id=212b5530"
import script from "./mobile-nav-main.vue?vue&type=script&lang=js"
export * from "./mobile-nav-main.vue?vue&type=script&lang=js"
import style0 from "./mobile-nav-main.vue?vue&type=style&index=0&id=212b5530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports